import React from "react";

import PropTypes from 'prop-types';

class MultiSelectFilterItem extends React.Component {
  constructor(...args) {
    super(...args);

    this._handleChange = this._handleChange.bind(this);
  }

  render() {
    return (
      <div className='js-multiselect-dropdown-item form-check' key={this.props.name}>
        <label className='form-check-label' title={this.props.description}>
          <input className='form-check-input' type='checkbox' value={this.props.name} defaultChecked={this.props.check} name={this.props.name} key={this.props.name} onChange={this._handleChange} />
          {this._getDescription()}
        </label>
      </div>
    );
  }

  _handleChange(event) {
    this.props.changeCallback(this.props.name, this.props.check);
  }

  _getDescription() {
    switch (this.props.description) {
    case "":
      return <span>(Blank)</span>;
    case null:
      return <span>(Not Present)</span>;
    default:
      return this.props.description;
    }
  }
}

MultiSelectFilterItem.propTypes = {
  name:           PropTypes.node.isRequired,
  description:    PropTypes.string, // null is allowed and will be rendered as "(Not Present)"
  changeCallback: PropTypes.func.isRequired,
  check:          PropTypes.bool.isRequired
};

export default MultiSelectFilterItem;
